import { ContentFeedback } from 'queries/feedback';
import { HttpClient } from '../http-client';

class FeedbackClient extends HttpClient {
  public async getAllFeedbacks(params: {
    sourceType: string;
    sourceId: string;
  }) {
    return this.get<ContentFeedback[], any>(
      `scarlet/content-feedback/source?sourceType=${params.sourceType}&sourceId=${params.sourceId}`,
    );
  }

  public async createFeedback({
    sourceType,
    feedbackType,
    sourceId,
    feedbackComment,
  }: {
    sourceType: string;
    feedbackType: any;
    sourceId: string;
    feedbackComment?: string;
  }) {
    return this.post<any, any>('scarlet/content-feedback', {
      feedbackComment,
      feedbackType,
      sourceId,
      sourceType,
    });
  }

  public async updateFeedback({
    sourceType,
    feedbackType,
    sourceId,
    feedbackId,
    feedbackComment,
  }: {
    sourceType: string;
    feedbackType: any;
    sourceId: string;
    feedbackId: number;
    feedbackComment?: string;
  }) {
    return this.put<any, any>(`scarlet/content-feedback/${feedbackId}`, {
      feedbackComment,
      feedbackType,
      sourceId,
      sourceType,
    });
  }

  public async deleteFeedback({ feedbackId }: { feedbackId: number }) {
    return this.delete<any, any>(`scarlet/content-feedback/${feedbackId}`);
  }
}

export const FeedbackAPI = new FeedbackClient();
